import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { add_category } from "../../reduxData/user/userAction";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import { useTranslation } from "react-i18next";

const AddCategoryModal = ({
  open,
  onClose,
  onSaved,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [name_nl, setName_nl] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    name: "",
    name_nl: "",
  });

  useEffect(() => {
    if (!open) {
      setName("");
      setName_nl("");
      setErrors({
        name: "",
        name_nl: "",
      });
    }
  }, [open]);

  // handle category name 
  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
    setErrors((prev) => ({
      ...prev,
      name: value.trim()
        ? ""
        : t("addCategoryModal.nameRequired"),
    }));
  };

  // handle dutch category name 
  const handleNameNlChange = (e) => {
    const value = e.target.value;
    setName_nl(value);
    setErrors((prev) => ({
      ...prev,
      name_nl: value.trim()
        ? ""
        : t("addCategoryModal.nameNlRequired"),
    }));
  };

  // handle form validations
  const validate = () => {
    let valid = true;
    const newErrors = {
      name: "",
      name_nl: "",
    };
    if (!name.trim()) {
      newErrors.name =
       t("addCategoryModal.nameRequired");
      valid = false;
    }
    if (!name_nl.trim()) {
      newErrors.name_nl = t("addCategoryModal.nameNlRequired");
      valid = false;
    }
    setErrors(newErrors);
    return valid;
  };

  // hanlde form submit functionality
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setLoading(true);
    const payload = {
      name : name,
      name_nl: name_nl,
    }
    const data = await add_category(payload, dispatch );
    setLoading(false);
    if (data?.data?.status) {
      setName("");
      setName_nl("");
      setErrors({
        name: "",
        name_nl: "",
      });
      onSaved();
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog className="modern-modal small-modal">
        <div className="modal-header-custom">
          <div>
            <h3>{t("addCategoryModal.title")}</h3>
          </div>
          <button
            className="close-btn"
            onClick={onClose}
          >
            ✕
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body-custom">
            <div className="form-group-modern">
              <label>
                {t("addCategoryModal.nameLabel")}
              </label>

              <input
                type="text"
                className={`modern-input ${errors.name
                    ? "input-error"
                    : ""
                  }`}
                placeholder={t("addCategoryModal.namePlaceholder")}
                value={name}
                onChange={handleNameChange}
              />

              {errors.name && (
                <div className="error_msg">
                  {errors.name}
                </div>
              )}
            </div>
            <div className="form-group-modern">
              <label>{t("addCategoryModal.nameNlLabel")}</label>
              <input
                type="text"
                className={`modern-input ${errors.name_nl ? "input-error" : "" }`}
                placeholder={t("addCategoryModal.nameNlPlaceholder")}
                value={name_nl}
                onChange={handleNameNlChange}
              />
              {errors.name_nl && (
                <div className="error_msg"> {errors.name_nl} </div>
              )}
            </div>
          </div>

          <div className="modal-footer-custom">
            <button
              type="button"
              className="secondary-btn"
              onClick={onClose}
            >
              {t("addCategoryModal.cancel")}
            </button>

            <button
              type="submit"
              className="primary-btn"
              disabled={loading}
            >
              {loading ? t("addCategoryModal.saving") : t("addCategoryModal.save")}
            </button>
          </div>
        </form>
      </ModalDialog>
    </Modal>
  );
};

export default AddCategoryModal;
